

import { mapState } from 'vuex'
import LandingOnboarding from '@/components/landing/LandingOnboarding.vue'

export default {

  components: {
    LandingOnboarding
  },

  data: () => {
    return {}
  },

  head () {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.title
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.description
        }
      ]
    }
  },

  nuxtI18n: {
    paths: {
      de: '/inserat/neu',
      se: '/annons/ny',
      nl: '/advertentie/nieuw',
      da: '/reklame/ny',
      pl: '/reklama/nowy',
      es: '/anuncio/nuevo',
      cs: '/reklama/novy',
      en: '/ad/new'
    }
  },

  computed: {
    ...mapState('customer', {
      adsInEditing: state => state.adsInEditing,
      hasAnyAds: state => state.hasAnyAds,
      merchant: state => state.merchant
    }),

    ...mapState('upload', {
      product: state => state.product,
      entityId: state => state.product.entityId,
      attributes: state => state.attributes,
      overlay: state => state.overlay
    }),

    createNew () {
      return this.$route.query.n === '1'
    },

    title () {
      return this.$t('ad.title')
    },
    description () {
      return this.$t('ad.description')
    },

    isMerchant () {
      return typeof this.merchant?.merchantId === 'number'
    }

  }

}
